import React from 'react';
import { observer } from 'mobx-react';
import { useAuthStore, useRechargeStore } from '../../contexts/mobx';
import { useNavigation } from '../../utils/use-navigation';
import { Recharge } from '../../stores/recharge';
import Table, { ColumnProps } from 'antd/lib/table';
import { CreateButton } from '../../components/action-buttons';
import { ImageHolder } from '../../components/image-holder';
import { PageTopBar } from '../../components/page-top-bar';
import { Tag } from '../../components/tag';
import { Spin } from 'antd';

export const RechargeImagesPage = observer(() => {
    const store = useRechargeStore();
    const navigation = useNavigation();
    const authStore = useAuthStore();

    const { hasManagementAccess } = authStore;

    if (!hasManagementAccess) {
        navigation.goToHome();
    }

    const renderImage = (_: unknown, record: Recharge) => {
        return <ImageHolder src={record.image.en ?? undefined} size={70} />;
    };

    const renderIsActive = (_: unknown, record: Recharge) => {
        return (
            <div>
                {record.active ? (
                    <Tag variant="success">Active</Tag>
                ) : (
                    <Tag variant="error">Inactive</Tag>
                )}
            </div>
        );
    };

    const columns = React.useMemo<ColumnProps<Recharge>[]>(
        () => [
            {
                title: 'Id',
                dataIndex: 'id',
                key: 'id',
                width: '5rem',
                ellipsis: true,
                render: (_: unknown, record: Recharge) => (
                    <span>{record.id}</span>
                ),
            },
            {
                title: 'Active',
                dataIndex: 'active',
                key: 'active',
                ellipsis: true,
                width: '7rem',
                render: renderIsActive,
            },
            {
                title: 'Type',
                dataIndex: 'type',
                key: 'type',
                ellipsis: true,
            },
            {
                title: 'Place',
                dataIndex: 'place',
                key: 'place',
                ellipsis: true,
            },
            {
                title: 'Image',
                key: 'image',
                ellipsis: true,
                render: renderImage,
            },
        ],
        []
    );

    React.useEffect(() => {
        store.fetchRechargeImageList();
    }, [store]);

    const goToEditPage = (o: Recharge) => () => {
        navigation.goToRechargeEdit(o.id);
    };

    return (
        <>
            <PageTopBar title="Recharge">
                <CreateButton onClick={() => navigation.goToRechargeCreate()} />
            </PageTopBar>

            {store.isFetchingList ? (
                <Spin />
            ) : (
                <Table<Recharge>
                    className="clickable_table_body_rows"
                    rowKey="id"
                    dataSource={store.rechargeList}
                    columns={columns}
                    loading={store.isFetchingList}
                    pagination={false}
                    bordered
                    onRow={(r) => ({
                        onClick: goToEditPage(r),
                    })}
                />
            )}
        </>
    );
});
